/* eslint-disable */
import moment from 'moment';

// Helper function to convert to lower unit
const convertToLowerUnit = (qty, unit) => {
	if (!qty || qty === '') return null;

	const quantity = parseFloat(qty);
	if (isNaN(quantity)) return null;

	switch (unit?.toLowerCase()) {
		case 'kg':
			return quantity * 1000; // Convert to grams
		case 'g':
		case 'gram':
			return quantity; // Already in grams
		case 'l':
		case 'liter':
		case 'ltr':
			return quantity * 1000; // Convert to ml
		case 'ml':
			return quantity; // Already in ml
		case 'piece':
		case 'pieces':
			return quantity; // Keep as is
		default:
			return quantity; // Default case
	}
};

// Deserializer function to parse API response
const deserializer = (state, tableData) => {
	// Check if orderWise mode (headers have orderId property)
	const isOrderWise = tableData?.headers?.some((h) => h.orderId);

	if (isOrderWise) {
		const orderMap = new Map();
		const poHeaders = tableData?.headers?.filter((h) => h.orderId) || [];

		tableData?.rows?.forEach((row) => {
			poHeaders.forEach((header) => {
				const cellData = row[header.id];
				if (cellData && cellData.qty && parseFloat(cellData.qty) > 0) {
					const poId = header.id;
					if (!orderMap.has(poId)) {
						// header.id is the PO ID
						orderMap.set(poId, {
							store: header._storeId,
							items: [],
							priority:
								state?.orderInfo?.[poId]?.isPriority ??
								header?.priority ??
								false,
							id: header?.jsonData?.parentDisplayPoId ?? header?.id,
						});
					}
					const group = orderMap.get(poId);
					const convertedQty = convertToLowerUnit(
						cellData.qty,
						cellData.unit
					);
					if (convertedQty !== null) {
						group.items.push({
							variantId: cellData.itemId,
							qty: convertedQty,
							productId: cellData.productId,
						});
					}
				}
			});
		});

		return {
			orderType: 2,
			date: moment(new Date()).format('MM/DD/YYYY'),
			scheduled: moment(new Date(state?.expectedDeliveryDate)).format(
				'MM/DD/YYYY'
			),
			toProcess: state?.internalProcess,
			shift: state?.internalShift,
			transferOrderType: 'DISPATCH',
			appOrderType: state?.orderType || 'CMS',
			type: 'PURCHASEORDER',
			workOrderType: 'PRODUCTION PLAN',
			fromStore: state?.fromStore,
			orderInfo: Array.from(orderMap.values()),
		};
	}

	const orderInfo = [];
	const storeHeaders =
		tableData?.headers?.filter(
			(header) =>
				header?.id !== 'Item Name' &&
				header?.id !== 'SkuCode' &&
				header?.id !== 'Total' &&
				header?.id !== 'S.No' &&
				header?.id !== 'Actions'
		) || [];
	storeHeaders.forEach((storeHeader) => {
		const storeItems = [];
		let storeId = null;

		tableData?.rows?.forEach((row) => {
			const storeCellData = row[storeHeader?.id];
			if (storeCellData) {
				const convertedQty = convertToLowerUnit(
					storeCellData.qty,
					storeCellData.unit
				);

				if (convertedQty !== null) {
					storeItems.push({
						variantId: storeCellData.itemId,
						qty: convertedQty,
						productId: storeCellData.productId,
					});
				}

				if (!storeId) {
					storeId = storeCellData?.storeId || storeHeader?.storeId || storeHeader?.id;
				}
			}
		});

		// Only add store if it has items and a valid storeId
		const finalStoreId = parseFloat(storeId);
		if (storeItems.length > 0 && !isNaN(finalStoreId)) {
			orderInfo.push({
				store: finalStoreId,
				items: storeItems,
				priority: state?.orderInfo?.[storeHeader.id]?.isPriority || false,
			});
		}
	});

	return {
		orderType: 2,
		date: moment(new Date()).format('MM/DD/YYYY'),
		scheduled: moment(new Date(state?.expectedDeliveryDate)).format(
			'MM/DD/YYYY'
		),
		toProcess: state?.internalProcess,
		shift: state?.internalShift,
		transferOrderType: 'DISPATCH',
		appOrderType: state?.orderType,
		type: 'PURCHASEORDER',
		workOrderType: 'PRODUCTION PLAN',
		fromStore: state?.fromStore,
		orderInfo: orderInfo,
	};
};

const validator = (state, processList, shiftList, tableData) => {
	const errors = {};
	if (!state?.fromStore) {
		errors.fromStore = 'Please select a store';
	}
	if (!state?.expectedDeliveryDate) {
		errors.expectedDeliveryDate = 'Please select a delivery date';
	}
	if (
		!state?.internalProcess &&
		state?.orderTypeInternal === 'CMS' &&
		processList?.length > 0
	) {
		errors.internalProcess = 'Please select a process';
	}
	if (
		!state?.internalShift &&
		state?.orderTypeInternal === 'CMS' &&
		shiftList?.length > 0
	) {
		errors.internalShift = 'Please select a shift';
	}
	if (tableData?.rows && tableData?.headers) {
		const storeHeaders = tableData.headers.filter(
			(header) =>
				header?.id !== 'Item Name' &&
				header?.id !== 'SkuCode' &&
				header?.id !== 'Total' &&
				header?.id !== 'S.No' &&
				header?.id !== 'Actions'
		);

		tableData?.rows?.forEach((row, rowIndex) => {
			const itemName = row?.['Item Name'];
			storeHeaders.forEach((store) => {
				const storeData = row?.[store?.id];
				if (
					storeData &&
					(storeData.qty === '' ||
						storeData.qty === null ||
						storeData.qty === undefined)
				) {
					errors[`${itemName}_${store?.id}`] = {
						message: 'Please enter quantity',
						rowIndex: rowIndex,
						storeName: store?.name,
						itemName: itemName,
					};
					return true;
				}
			});
		});
	}
	return errors;
};

const buyerDeserlizer = (state, tableData) => {
	const orderInfo = [];
	const storeHeaders =
		tableData?.headers?.filter(
			(header) =>
				header?.id !== 'Item Name' &&
				header?.id !== 'SkuCode' &&
				header?.id !== 'Total' &&
				header?.id !== 'S.No' &&
				header?.id !== 'Actions'
		) || [];
	storeHeaders.forEach((storeName) => {
		const storeItems = [];
		let vendorId = null;
		let vendorlocationId = null;

		tableData?.rows?.forEach((row) => {
			const storeData = row[storeName?.id];
			if (storeData) {
				const convertedQty = convertToLowerUnit(
					storeData.qty,
					storeData.unit
				);

				if (convertedQty !== null) {
					storeItems.push({
						variantId: storeData.itemId,
						qty: convertedQty,
						productId: storeData.productId,
					});
				}

				if (!vendorId) {
					const [id, locationId] = storeData?.storeId?.split('_');
					vendorId = parseFloat(id);
					vendorlocationId = parseFloat(locationId);
				}
			}
		});

		// Only add store if it has items
		if (storeItems.length > 0 && vendorId) {
			orderInfo.push({
				vendorId: vendorId,
				vendorlocationId: vendorlocationId,
				items: storeItems,
			});
		}
	});

	return {
		orderType: 8,
		date: moment(new Date()).format('MM/DD/YYYY'),
		scheduled: moment(new Date(state?.expectedDeliveryDate)).format(
			'MM/DD/YYYY'
		),
		transferOrderType: 'DISPATCH',
		appOrderType: state?.orderType,
		type: 'BUYER',
		workOrderType: 'PRODUCTION PLAN',
		fromStore: state?.fromStore,
		store: state?.fromStore,
		orderInfo: orderInfo,
	};
};

const multipleConfigPo = {
	deserializer,
	validator,
	buyerDeserlizer,
};

export default multipleConfigPo;
